import { Tag } from '@components';
import { useScreenSize } from '@hooks';
import CourseCardGradient from '@pngs/CoursesPage/CourseCardGradient.png';
import { Flex, theme, Typography } from '@styles';
import { func, number, oneOfType, string } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const OnboardingCard = ({ cover, handleNavigate, materials, time, title }) => {
  const { device, isMobile, isTabletLG } = useScreenSize();
  const { t } = useTranslation();

  return (
    <Flex
      flex={1}
      flexDirection="column"
      gap={device === 'desktop' ? 40 : 24}
      minHeight={600}
      mt={isMobile ? 36 : 0}
      onClick={handleNavigate}
      pointer
    >
      <Flex
        backgroundImage={cover}
        backgroundSize="cover"
        flex={1}
        flexDirection="column"
      >
        <Flex
          backgroundImage={CourseCardGradient}
          backgroundRepeat="no-repeat"
          backgroundSize="cover"
          flex={1}
          flexDirection="column"
          pb={16}
          px={16}
        >
          <Flex
            flexDirection="column"
            gap={10}
            mt={isTabletLG ? 'auto' : 0}
            position="relative"
            top="50%"
          >
            <Flex gap={8} width="100%">
              <Tag content={time} variant="time" />
              {materials && <Tag content={materials} variant="material" />}
            </Flex>
            <Typography
              color={theme.colors.white[100]}
              mt={14}
              variant="BN-bold-s43-lh38"
            >
              {title}
            </Typography>
            <Typography
              color={theme.colors.white[60]}
              textOverflow="ellipsis"
              variant="MS-regular-s14-lh22"
            >
              {t('CoursesPage.OnboardingDescription')})
            </Typography>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

OnboardingCard.defaultProps = {
  materials: null,
};

OnboardingCard.propTypes = {
  cover: string.isRequired,
  handleNavigate: func.isRequired,
  materials: oneOfType([number, string]),
  time: oneOfType([number, string]).isRequired,
  title: string.isRequired,
};

export default OnboardingCard;
